module.exports = __webpack_public_path__ + "img/csr_banner_mobile.682b9109.jpg";